import React from 'react';
import '../../styling/StageFlowPoints.css';

const StageFlowPoints = ({ ticket }) => {
    // Convert stage codes to display format (underscores -> spaces)
    const stages = ticket.selectedStageName;

    // Normalize ticket.stage to uppercase for comparison
    const currentStage = ticket?.stage;
    const currentIndex = stages.indexOf(currentStage.replace(/_/g, " "));

    return (
        <div className="stage-flow-container">
            {stages.map((stage, index) => {
                let isCompleted = index < currentIndex;
                let isActive = index === currentIndex;
                let isFailed = false;
                let isRework = false;
                
                if ((ticket.status === 'ERROR') && stage === currentStage) {
                    isCompleted = false;
                    isActive = true;
                    isFailed = true;
                }

                if (ticket.status === 'REWORK' && stage === currentStage) {
                    isRework = true;
                }

                if ((currentStage === 'Ticket Closed' && ticket?.status === 'DONE')) {
                    isCompleted = true;
                }

                if (currentStage === stage && ticket?.status === "COMPLETED"){
                    isCompleted = true;
                }

                return (
                    stage !== 'All Tickets' && 
                    <React.Fragment key={stage}>
                        <div className="stage-point">
                            <div
                                className={`dot ${isCompleted || (currentStage === 'Ticket Closed' && ticket?.status === 'COMPLETED') ? 'completed' : ''} ${isActive || currentStage !== 'Ticket Closed' ? 'active' : ''} ${isFailed ? 'failed' : ''} ${isRework ? 'rework' : ''}`}
                            >
                                {isCompleted || (currentStage === 'Ticket Closed' && ticket?.status === 'COMPLETED') ? '✔' : isFailed ? 'X' : ''}
                            </div>
                            <div className="stage-label">{stage}</div>
                        </div>

                        {/* Connector except for last item */}
                        {index < stages.length - 1 && <div className="connector">→</div>}
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default StageFlowPoints;
